import { Todo } from 'api/clients/TodoClient'
import { LayerChange } from 'providers/LayerChangesProvider/types'
import { Comment } from 'types'

export enum CollabItemType {
  Comment = 'Comment',
  Todo = 'Todo',
  TrackedChange = 'TrackedChange',
  All = 'All',
}

export type CollabItem = CommentItem | TodoItem | TrackedChangeItem

export type CommentItem = {
  type: CollabItemType.Comment
  item: Comment
}

export type TodoItem = {
  type: CollabItemType.Todo
  item: Todo
}

export type TrackedChangeItem = {
  type: CollabItemType.TrackedChange
  item: LayerChange
}

export interface CommentChannelMessage {
  comment: Comment
  action: 'add' | 'remove'
  comment_id: number
}

export interface TodoChannelMessage {
  todo: Todo
  action: 'add' | 'remove'
  todo_id: number
}

export enum DocMode {
  Cleanup = 'cleanup',
  Editor = 'editor',
  Focus = 'focus',
  Decision = 'decision',
}
